export  class Constants {
	public static readonly recaptchaSiteKey: string = '6Lc0wKoUAAAAALcBiOB-UdNpLqgxncAh2yKX7n1P';
	public static readonly apiBaseUrl: string = process.env.VUE_APP_API_BASE_URL;
}
